<template>
  <div class="edit-dialog" @contextmenu.stop>
    <el-dialog
      :title="type === '' ? '批量导出订单信息' : '导出订单信息'"
      width="400px"
      height="300px"
      top="calc( 50vh - 150px )"
      custom-class="edit-share"
      center
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      :handleCancel="handleCancel"
    >
      <div class="setting-container">
        <div class="setting-item" v-if="type === ''">
          <div class="title">订阅来源：</div>
          <el-radio-group v-model="module">
            <el-radio class="title-radio" :label="'cloud_read_ebook'">书刊</el-radio>
            <el-radio class="title-radio" :label="'cloud_read_album'">专辑</el-radio>
          </el-radio-group>
        </div>
        <div class="setting-item">
          <div class="title">订单时间：</div>
          <el-select class="personal-item-select" size="mini" v-model="exportYear">
            <el-option v-for="(item, index) in exportYearOptions" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-select class="personal-item-select" size="mini" v-model="exportMonth">
            <el-option v-for="(item, index) in exportMonthOptions" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </div>
      <div class="default-edit-footer" id="edit-footer">
        <div class="edit-footer-item left" @click="exportExcel()">保存</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCurDate } from '@/utils'
import chargeManager from '../../../api/chargeManager'

export default {
  name: 'ExportDialog',
  data() {
    return {
      dialogVisible: false,
      module: '',
      exportYearOptions: [],
      exportYear: '',
      exportMonthOptions: [],
      exportMonth: '',
      goodsId: 0
    }
  },
  props: {
    type: {
      default: ''
    }
  },
  computed: {
    bookObj() {
      return this.$store.state.config.bookObj
    },
    userName() {
      return localStorage.getItem('username')
    }
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    exportExcel() {
      if (!this.module) {
        this.$message('请选择商品类型')
        return
      }
      if (!this.exportYear || !this.exportMonth) {
        this.$message('请选择日期')
        return
      }
      let startTime = this.exportYear + '-' + this.exportMonth + '-' + '01'
      let endTime = this.exportYear + '-' + this.exportMonth + '-' + '31'
      let a = document.createElement('a')
      a.href = `${window.PROJECT_CONFIG.BASE_URL}/ebook/cloudReadOrder/exportOrderData?goodsId=${this.goodsId}&worksType=${this.module}&userName=${this.userName}&startTime=${startTime}&endTime=${endTime}`
      a.click()
      a.style.display = 'none'
    },
    initSetting() {
      this.module = ''
      this.exportMonth = ''
      this.exportYear = ''
      this.goodsId = 0
    },
    initDate() {
      const result = getCurDate()
      this.exportYearOptions = []
      let exportYear = result.year
      for (let i = 1; i < 13; i++) {
        this.exportMonthOptions.push({ value: i, label: i + '月' })
      }
      for (let i = 2023; i <= exportYear; i++) {
        this.exportYearOptions.push({ value: i, label: i + '年' })
      }
    }
  },
  mounted() {
    this.initDate()
  }
}
</script>
<style lang="scss" scoped>
.setting-container {
  width: 250px;
  margin: 0 auto;
  .setting-item {
    margin-bottom: 10px;
    font-size: 12px;
    display: flex;
    align-items: flex-end;
    .title {
      width: 65px;
    }
    .el-select {
      width: 90px;
      height: 20px;
      margin-right: 10px;
    }
    .el-radio-group {
      display: flex;
    }
    span {
      margin-right: 10px;
    }
  }
}
.default-edit-footer {
  height: 50px;
  line-height: 36px;
  font-size: 14px;
  padding-top: 10px;
  background-color: #ffffff;
  text-align: center;

  .edit-footer-item {
    cursor: pointer;
    display: inline-block;
    height: 36px;
    border: 1px solid #df5813;
    text-align: center;
    width: 100px;
    &.left {
      background-color: #df5813;
      color: #fff;
    }
    &.right {
      margin-left: 30px;
    }
  }
}
</style>
<style lang="scss">
.setting-item {
  .el-input {
  }
  .title-radio {
    .el-checkbox__label {
      font-size: 12px;
    }
  }
}
</style>
